// @flow
// $FlowFixMe
import React from 'react';
import styled from 'styled-components';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
import { getBaseURL } from '@finect/front-utils/env';
import { H4, H6 } from '@finect/tabular-core/Headings';
import { OptionCard } from './../SubscribeModal/components';

const Container = styled.div`
  padding: 0 20px 40px 20px;

  > h4,
  > h6 {
    margin-left: 20px;
  }

  p {
    margin: 0 0 10px;
    font-size: 14px;
  }
`;

type Props = {
  user: Object
};

export const PlusArticleCard = (props: Props) => {
  const paymentUrl = `/servicios/finect-plus/comprar`;

  const buyUrl = props.user.isLoggedIn
    ? `${paymentUrl}`
    : `${getLoginBaseURL()}?next=${getBaseURL() + paymentUrl}`;

  return (
    <Container>
      <H4>¡Vaya! Este contenido es solo para miembros Plus.</H4>
      <H6>
        ✅ Actualiza a <b>Finect Plus</b> para acceder a este y a muchos otros contenidos exclusivos.
      </H6>
      <H6 style={{ paddingLeft: '19px' }}>
        Además, si eres profesional del sector podrás disfrutar de <b>3 meses gratis</b>.
      </H6>
      <OptionCard plus option="basic" url={buyUrl} />
    </Container>
  );
};
